import * as THREE from 'three';
import { colors } from './colors.js';


class Permutohedron {
    constructor (position, dim, scale, opacity, color) {

        this.position = position;
        this.dim = dim;
        this.scale = scale ?? 1.
        this.opacity = opacity ?? .15
        this.color = color ?? 0x11ff11

        if ( this.dim == 4 ) {
			this.vertexScale = Math.sqrt(5);
            this.positions = [[ 0.,  1.,  2.],
                              [ 1.,  0.,  2.],
                              [ 2.,  0.,  1.],
                              [ 2., -1.,  0.],
                              [ 2.,  0., -1.],
                              [ 2.,  1.,  0.],
                              [ 1.,  2.,  0.],
                              [ 0.,  2.,  1.],
                              [-1.,  2.,  0.],
                              [ 0.,  2., -1.],
                              [ 0.,  1., -2.],
                              [ 1.,  0., -2.],
                              [ 0., -1., -2.],
                              [-1.,  0., -2.],
                              [-2.,  0., -1.],
                              [-2.,  1.,  0.],
                              [-2.,  0.,  1.],
                              [-2., -1.,  0.],
                              [-1., -2.,  0.],
                              [ 0., -2., -1.],
                              [ 1., -2.,  0.],
                              [ 0., -2.,  1.],
                              [ 0., -1.,  2.],
                              [-1.,  0.,  2.]];
            this.faces = [ 0, 1, 2,
                           1, 3, 2,
                           0, 2, 5,
                           0, 5, 7,
                           6, 7, 5,
                           6, 10, 9,
                           6, 11, 10,
                           6, 4, 11,
                           6, 5, 4,
                           5, 2, 3,
                           5, 3, 4,
                           1, 20, 3,
                           1, 21, 20,
                           1, 22, 21,
                           0, 22, 1,
                           0, 23, 22,
                           6, 9, 7,
                           9, 8, 7,
                           9, 15, 8,
                           9, 14, 15,
                           9, 13, 14,
                           9, 10, 13,
                           13, 10, 11,
                           13, 11, 12,
                           11, 4, 3,
                           11, 3, 20,
                           11, 20, 19,
                           11, 19, 12,
                           18, 17, 14,
                           18, 14, 13,
                           18, 13, 12,
                           18, 12, 19,
                           14, 17, 16,
                           14, 16, 15,
                           19, 20, 21,
                           19, 21, 18,
                           21, 22, 23,
                           21, 23, 16,
                           21, 16, 17,
                           21, 17, 18,
                           16, 8, 15,
                           16, 7, 8,
                           16, 0, 7,
                           16, 23, 0 ];
        }
        else if ( dim == 3 ) {
			this.vertexScale = Math.sqrt(3);
            this.positions = [[ -1.,  0.,  1.],
                              [ 0.,  -1.,  1.],
                              [ 1.,  -1.,  0.],
                              [ 1.,  0.,  -1.],
                              [ 0.,  1.,  -1.],
                              [ -1.,  1.,  0.]];
            this.faces = [ 0, 1, 5,
                           5, 1, 4,
                           4, 1, 3,
                           3, 1, 2];
        }
		else {
			this.vertexScale = Math.sqrt(2);
            this.positions = [[ -1.,  0.,  1.],
                              [ 1.,  0.,  -1.]];
            this.faces = [];
		}
        const geometry = new THREE.SphereGeometry(.1 * this.scale, 32, 32);
        const material = new THREE.MeshLambertMaterial( { color: this.color, transparent: true, vertexColors: true} );
        this.group = new THREE.Group();
        // this.labels = new THREE.Group();
        // this.vertices = new THREE.Group();
        // for (let i = 0; i < this.positions.length; i++) {
        //
        //     const [x, y, z] = this.positions[i];
        //     let sphere = new THREE.Mesh(geometry, material);
        //
        //     sphere.position.x = x * this.scale;
        //     sphere.position.y = y * this.scale;
        //     sphere.position.z = z * this.scale;
        //
        //     // Allow each vertex to be colored independently
        //     sphere.material = sphere.material.clone();
        //
        //     this.vertices.add( sphere );
        // }
        // this.group.add(this.vertices);
        // this.group.add(this.labels);
        this.group.add(this.construct_polytope());
    }

    color_vertex( v, color, visible=true ) {
        const tcolor = new THREE.Color(color);
        v.material.color = tcolor;
        let label = this.vertexLabel[v.uuid];
        label.element.style.color = '#' + tcolor.getHexString();
        // v.visible = visible;
        label.visible = visible;
    }

    color_vertices( color, opacity, visible=true ) {
        for ( let i = 0; i < this.vertices.children.length; i++ ) {
            this.color_vertex(this.vertices.children[i], color, opacity);
        }
    }

    construct_polytope() {

        let positions = [].concat(...this.positions);
        const geometry = new THREE.PolyhedronBufferGeometry( positions, this.faces, this.vertexScale * this.scale, 0 );
        // const material = new THREE.MeshNormalMaterial({flatShading: true, transparent: true, opacity: this.opacity});
        const material = new THREE.MeshPhysicalMaterial({flatShading: true, transparent: true, reflectivity: 1., opacity: this.opacity, color: this.color});
        // const material = new THREE.MeshPhysicalMaterial({ transparent: true, opacity: 0.5, reflectivity: 0., side: BackSide});
        let obj = new THREE.Mesh(geometry, material);

        const [x, y, z] = this.position;
        obj.translateX(x);
        obj.translateY(y);
        obj.translateZ(z);

        return obj;
    }

    add_to ( scene ) {
        scene.add(this.group);
    }
}


function hyperplane(normal, color) {
	// const geometry = new THREE.PlaneGeometry( 5, 20, 32 );
	// const plane = new THREE.Mesh( geometry, material );
	// const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 0 );

	const material = new THREE.MeshLambertMaterial( {color: color, side: THREE.DoubleSide, transparent: true, opacity: .9} );
    // const material = new THREE.MeshNormalMaterial({flatShading: true, transparent: true, side: THREE.DoubleSide, opacity: 0.9});

	const geometry = new THREE.PlaneGeometry(6, 6);
	const mesh = new THREE.Mesh(geometry, material);

	const [x, y, z] = normal;
	mesh.lookAt(new THREE.Vector3(x, y, z));
	// const helper = new THREE.PlaneHelper( plane, 20, 0xffff00 );
	return mesh;
}


function braidArrangement() {

	let braid = new THREE.Group();

	const normals = [[1, -1, 0],
					 [1, 0, -1],
					 [0, -1, -1],
					 [0, 1, -1],
					 [-1, 0,-1],
					 [-1, -1,0]];


	const bcolors = [colors.red,
	                 colors.green,
	                 colors.blue,
	                 colors.purple,
		   		     colors.yellow,
		   		     colors.teal,
		   		     colors.darkblue,
		   		     colors.darkred,
		   		     colors.darkgreen,
		   		     colors.white,
					 colors.grey]
	
	for (let i=0; i < normals.length; i++) {
		braid.add( hyperplane(normals[i], bcolors[i]) );
	}
	return braid;
}


class Simplex {
    constructor (position, dim, scale, colors) {

        this.position = position;
		this.dim = dim;
        this.scale = scale;
		if ( this.dim == 4 ) {
			this.positions = [[ 1.,  1.,  1.],
							  [ -1., -1., 1.],
							  [ -1.,  1.,  -1.],
							  [ 1.,  -1.,  -1.]];
			this.faces = [ 0, 2, 3,
			               3, 2, 1,
			               1, 0, 3,
			               2, 0, 1,
			               ];
		}
		else if ( this.dim == 3 ) {
			this.positions = [[ 2.,  0.,  0.],
							  [ 0.,  2., 0.],
							  [ 0.,  0., 2.]];
			this.faces = [ 0, 2, 1 ];
		}
		else {
			this.positions = [[ 2.,  0.,  0.],
							  [ 0.,  0., 2.]];
			this.faces = [];
		}
        this.colors = colors;
        const geometry = new THREE.SphereGeometry(.1, 32, 32);
        const material = new THREE.MeshLambertMaterial( { color: 0x555555, transparent: true, vertexColors: true, opacity: 0.5 } );
        this.vertices = new THREE.Group();
        for (let i = 0; i < this.positions.length; i++) {

            const [x, y, z] = this.positions[i];
            let sphere = new THREE.Mesh(geometry, material);

            sphere.position.x = x;
            sphere.position.y = y;
            sphere.position.z = z;

            // Allow each vertex to be colored independently
            sphere.material = sphere.material.clone();
            sphere.material.color = new THREE.Color(this.colors[i]);

            this.vertices.add( sphere );

            const text = document.createElement( 'div' );
            text.className = 'label';
            text.style.color = '#' + sphere.material.color.getHexString();
            text.textContent = 'Class ' + String.fromCharCode(97 + i);

            const label = new CSS2DObject( text );
            label.position.copy( sphere.position );
            this.vertices.add( label );
        }
    }

    construct_polytope() {

        let positions = [].concat(...this.positions);
        const geometry = new THREE.PolyhedronBufferGeometry( positions, this.faces, this.scale, 0 );
        const material = new THREE.MeshPhysicalMaterial({ transparent: true, opacity: this.opacity, reflectivity: .2, side: THREE.DoubleSide});
        // const material = new THREE.MeshNormalMaterial({flatShading: true, transparent: true, opacity: 0.1});
        let object = new THREE.Mesh(geometry, material);

        const [x, y, z] = this.position;
        object.translateX(x);
        object.translateY(y);
        object.translateZ(z);

        return object;
    }

    add_to ( scene ) {
        scene.add(this.vertices);
        this.scene = scene;
        scene.add(this.construct_polytope());
    }

    project ( probs ) {
        // For each point
        let projections = [];
        for ( let i = 0; i < probs.length; i++ ) {
            let point = probs[i];
            let point_coords = [0., 0., 0.];
            for ( let j = 0; j < point.length; j++ ) {
                let vertex = this.positions[j];
                for ( let k = 0; k < point_coords.length; k++ ) {
                    point_coords[k] += vertex[k] * point[j];
                }
            }
            projections.push(point_coords);
        }
        return projections;
    }

    plot_project ( probs ) {
        let proj = this.project( probs );
        const geometry = new THREE.SphereGeometry(.05, 32, 32);
        const material = new THREE.MeshLambertMaterial( { color: 0x55cc55, transparent: true, vertexColors: true } );
        if ( this.points !== undefined ) {
            this.scene.remove(this.points);
        }
        this.points = new THREE.Group();
        for (let i = 0; i < proj.length; i++) {

            const [x, y, z] = proj[i];
            let sphere = new THREE.Mesh(geometry, material);

            sphere.position.x = x;
            sphere.position.y = y;
            sphere.position.z = z;

            // Allow each vertex to be colored independently
            sphere.material = sphere.material.clone();
            const argm = argmax(probs[i]);
            sphere.material.color = new THREE.Color(this.colors[argm]);

            this.points.add( sphere );
        }
        this.scene.add( this.points );
    }
}


export { Permutohedron, Simplex, braidArrangement };
